import { keyframes } from "@emotion/css";
import styled from "@emotion/styled";
const ring = keyframes `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const Spinner = {
    Ring: styled.div `
    display: inline-block;
    position: relative;
    position: absolute;
    width: 40px;
    height: 40px;
    z-index: 15;
    left: 3.25rem;
    top: 4.5em;
    & > div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 32px;
      height: 32px;
      margin: 4px;
      border: 4px solid #fff;
      border-radius: 50%;
      animation: ${ring} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #fff transparent transparent transparent;
    }
    & > div:nth-of-type(1) {
      animation-delay: -0.45s;
    }
    & > div:nth-of-type(2) {
      animation-delay: -0.3s;
    }
    & > div:nth-of-type(3) {
      animation-delay: -0.15s;
    }
  `,
};
export default Spinner;
//# sourceMappingURL=Spinner.styled.js.map